import { useState } from 'react';
import { SnackbarSeverityType } from '../../../enums';

export const useToast = () => {
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: SnackbarSeverityType.success
  });

  const showToast = (message: string, severity: SnackbarSeverityType) =>
    setToast({ open: true, message, severity });

  const handleCloseToast = () => setToast((t) => ({ ...t, open: false }));

  return { toast, showToast, handleCloseToast };
};
